import classnames from 'classnames';
import { HTMLProps, ReactNode } from 'react';
import './Modal.scss';

export interface ModalLayoutProps extends HTMLProps<HTMLDivElement> {
  className?: string;
  children?: ReactNode;
}
export const ModalLayout = ({ className, children, ...rest }: ModalLayoutProps) => (
  <div className={classnames('modal', className)} {...rest}>
    {children}
  </div>
);
